"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const logged_1 = require("./controllers/logged");
const constants_1 = require("./constants");
const storage_1 = require("./services/storage");
const workers_1 = require("./services/workers");
let worker = null;
function getNotifications({ context, addNotifications, customer, userCompatibilities, userPo, userBundle, userFlags, userRecom, userPq, skipCache, }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const notificationSessionMode = (0, storage_1.getLoggedStatus)();
            if (notificationSessionMode === constants_1.LOGGED_STATUS.PUBLIC) {
                worker = worker
                    ? (0, workers_1.releaseWorkerInstance)(worker, "public_session")
                    : worker;
                addNotifications === null || addNotifications === void 0 ? void 0 : addNotifications({
                    notifications: {},
                    notificationList: [],
                    unreadNotifications: [],
                    finish: true,
                    replace: true,
                });
                return;
            }
            const controllerResult = yield (0, logged_1.loggedNotificationController)({
                worker,
                context,
                addNotifications,
                userCompatibilities,
                userPo,
                userBundle,
                userFlags,
                userRecom,
                userPq,
                customer,
                skipCache,
                notificationSessionMode,
            });
            if (controllerResult && Object.prototype.hasOwnProperty.call(controllerResult, "worker")) {
                worker = controllerResult.worker;
            }
        }
        catch (e) {
            console.log("Notifications error: ", JSON.stringify(e), e);
            addNotifications === null || addNotifications === void 0 ? void 0 : addNotifications({
                notifications: {},
                notificationList: [],
                unreadNotifications: [],
                finish: true,
                replace: true,
            });
        }
    });
}
exports.default = getNotifications;
//# sourceMappingURL=index.js.map